<template>
  <div v-if="show" class="NavigatorBar">
    <div
      class="app-nav-top"
      :style="'background-image:url(\'' + run('get', 'ship.banner') + '\')'"
    >
      <div class="container">
        <div class="wrapper">
          <div class="ship-logo"><img :src="run('get', 'ship.logo')" /></div>
          <div class="ship-info">
            <h2 v-html="run('get', 'ship.name')"></h2>
            <p v-html="run('get', 'ship.desc')"></p>
          </div>
          <div class="ship-info-right">
            <div class="ship-date">
              <div class="from-date" v-html="run('get', 'ship.fromDate')"></div>
              <div>-</div>
              <div class="to-date" v-html="run('get', 'ship.toDate')"></div>
            </div>
            <div class="total-guest">
              <span>{{ tran("TOTAL_GUESTS") }}</span>
              <span>{{ run("totalGuest") }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="app-nav-middle">
      <div class="container">
        <div class="wrapper">
          <div class="app-prev">
            
            <button
              v-if="canPrev || !data.backUrl"
              type="button"
              class="btn"
              :disabled="!canPrev"
              @click.prevent="prev"
            >
              <span class="fa fa-chevron-left"></span>
            </button>
            <a
              v-else
              type="button"
              class="btn btn-booking-back"
              :href="data.backUrl"
            >
              <span class="fa fa-chevron-left"></span>
          </a>
          </div>
          <div class="app-steps">
            <ul>
              <li
                @click="run('goGroupStep', step)"
                v-for="(step, index) in steps"
                :key="index"
                class="step"
                :class="{
                  active: run('get', 'currentGroupStep') == step,
                  pointer:
                    index < steps.indexOf(run('get', 'currentGroupStep')),
                }"
                :step="index + 1"
                :style="{ 'z-index': steps.length - index }"
                :disabled="
                  index >= steps.indexOf(run('get', 'currentGroupStep'))
                    ? ''
                    : undefined
                "
              >
                <span class="step-inner"
                  ><span>{{ index + 1 }}</span
                  ><span>{{ tran("STEP_" + step) }}</span></span
                >
              </li>
            </ul>
          </div>

          <div
            class="price"
            v-if="run('get', 'currentGroupStep') == 'select_room'"
            v-html="run('get', 'priceStarting', '')"
          ></div>
          <div
            class="dropdown trip-subtotals"
            v-if="subtotal && run('get', 'currentGroupStep') == 'customize_trip'"
          >
            <div
              class="dropdown-toggle pointer"
              type="button"
              data-toggle="dropdown"
            >
              {{ tran("TRIP_SUBTOTAL") }} <span class="caret"></span>
            </div>
            <div
              class="dropdown-menu"
              v-html="subtotal"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="app-nav-bottom">
      <div class="container">
        <div class="wrapper">
          <ul class="sub-steps">
            <li
              @click="run('goStep', index)"
              v-for="(step, index) in groupStep"
              :key="index"
              class="step"
              :class="{
                active: run('get', 'currentStep') == step,
                pointer: index < run('get', 'step'),
              }"
              :step="index + 1"
              :disabled="index >= run('get', 'step') ? '' : undefined"
            >
              <span>
                <span class="step-inner"
                  ><span>{{ index + 1 }}</span
                  ><span>{{ tran("STEP_" + step) }}</span></span
                >
              </span>
            </li>
          </ul>
          <ul
            class="user-rooms"
            v-if="
              ['RoomChoose', 'RoomCategory'].includes(run('get', 'currentStep')) &&
              run('get', 'numberOfRoom') > 1
            "
          >
            <li
              :class="
                'current-user-room-' +
                (index + 1) +
                (index == currentUserRoomIndex ? ' active' : '') +
                (userRooms[index].userChooseRoom && userRooms[index].roomNumber
                  ? ' complete'
                  : '')
              "
              v-for="(userRoom, index) in userRooms"
              :key="index"
            >
              <span v-html="tran('ROOM_INDEX', { room: index + 1 })"></span>
              <span v-html="userRoom.categoryTitle"></span>
            </li>
          </ul>
          <ul
            class="user-rooms room-numbers"
            v-if="
              ['CustomizeOffer', 'CustomizePreference'].includes(
                run('get', 'currentStep')
              ) && run('get', 'numberOfRoom') > 1
            "
          >
            <li
              :class="
                'current-user-room-' +
                (index + 1) +
                (index == currentUserRoomIndex ? ' active' : '') +
                (userRooms[index].userChooseRoom && userRooms[index].roomNumber
                  ? ' complete'
                  : '')
              "
              v-for="(userRoom, index) in userRooms"
              :key="index"
            >
              <div>
                <span v-html="userRoom.categoryTitle"></span
                >
                <span v-if="userRoom.roomNumber">
                  #{{ userRoom.roomNumber }}</span
                >
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavigatorBar",
  props: {
    run: Function,
  },
  data: function () {
    return {
      steps: ["select_room", "customize_trip", "review_pay"],
      // steps: [
      //   {
      //     key: "select_room",
      //     label: this.tran("STEP_SELECT_A_ROOM"),
      //   },
      //   {
      //     key: "customize_trip",
      //     label: this.tran("STEP_SELECT_A_ROOM"),
      //   },
      //   {
      //     key: "review_pay",
      //     label: this.tran("REVIEW_AND_PAY"),
      //   },
      // ],
    };
  },
  watch: {
    // currentUserRoomIndex(n) {
    //   this.run("set", `rooms.${n}.userChooseRoom`, true);
    // },
  },
  computed: {
    data() {
      return this.run("get", "data");
    },
    currentUserRoomIndex() {
      return this.run("get", "currentUserRoomIndex");
    },
    show: function () {
      // if(this.run('currentStep')=='ProductSelect'){
      //   return false;
      // }
      return true;
    },
    canNext: function () {
      return this.run("validate");
    },
    canPrev: function () {
      if (this.data.step < 1) {
        return false;
      }
      return true;
    },
    groupStep() {
      const groupStep = this.run("groupStep");
      const steps = this.run("steps");
      const currentStep = this.run("currentGroupStep");
      const rs = {};
      for (const step in groupStep) {
        if ((groupStep[step] ?? "") == currentStep) {
          rs[steps.indexOf(step)] = step;
        }
      }
      return rs;
    },
    userRooms() {
      return this.run("get", "rooms");
    },
    subtotal(){
      return this.run('get', 'subtotal', '');
    }
  },
  methods: {
    tran(key, replaces) {
      return this.run("tran", key, replaces);
    },
    next: function () {
      this.run("next");
    },
    prev: function () {
      this.run("prev");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
